import $, { Tween } from 'jquery'
import { TweenMax, Expo } from 'gsap'
import Swiper from 'swiper'
import Rellax from 'rellax'
import popins from './popins'

export default {
  init() {
    $('.page__hero-readmore').on('click', function() {
      $('html, body').animate( { scrollTop: $(this).closest('.page__hero').next().offset().top - 100 }, 500 )
			return false
    })

    if ($('body').hasClass('tax-wine_category')) {
      $('.menu-item-object-wine').addClass('current-menu-item')
    }
    
    const setHeaderPosition = () => {
      if (window.scrollY > 0) {
        $('.header').addClass('header--sticky')
      } else {
        $('.header').removeClass('header--sticky')
      }
    }

    setHeaderPosition()

    window.addEventListener('scroll', setHeaderPosition)

    let isMobileMenuOpen = false

    $('.header__burger').on('click', () => {
      TweenMax.to('.mobileMenu', .5, {
        autoAlpha: isMobileMenuOpen ? 0 : 1
      })

      if (isMobileMenuOpen) {
        $('.header__burger-icon').addClass('icon-burger')
        $('.header__burger-icon').removeClass('icon-burger-close')
      } else {
        $('.header__burger-icon').removeClass('icon-burger')
        $('.header__burger-icon').addClass('icon-burger-close')
      }

      $('body').toggleClass('mobileMenuOpen')
      isMobileMenuOpen = !isMobileMenuOpen
    })

    $('.header .menu-item-object-wine').on('mouseover', () => {
      if (!IS_MOBILE) {
        $('.header').addClass('header--winesNavOpen')
        $('.header').removeClass('header--domainesNavOpen')
      }
    })

    $('.toggleDomaineMenu').on('mouseover', () => {
      if (!IS_MOBILE) {
        $('.header').addClass('header--domainesNavOpen')
        $('.header').removeClass('header--winesNavOpen')
      }
    })

    $('.header').on('mouseleave', () => {
      if (!IS_MOBILE) {
        $('.header').removeClass('header--winesNavOpen')
        $('.header').removeClass('header--domainesNavOpen')
      }
    })

    $('.menu-item').not('.toggleDomaineMenu').not('.menu-item-object-wine').on('mouseover', () => {
      if (!IS_MOBILE) {
        $('.header').removeClass('header--winesNavOpen')
        $('.header').removeClass('header--domainesNavOpen')
      }
    })

    $('.mobileMenu .menu-item-type-post_type_archive').append($('.mobileMenu__wines'))
    $('.mobileMenu .menu-item-type-post_type_archive').append($('<div class="mobileMenu__toggleWines"></div>'))
    
    $('.mobileMenu__toggleWines').on('click', () => {
      $('.mobileMenu__toggleWines').toggleClass('mobileMenu__toggleWines--expanded')
      $('.mobileMenu__wines').toggleClass('mobileMenu__wines--expanded')
    })

    popins.init()

    var rellax = new Rellax('.parallax', {
      center: true,
      speed: 2
    });

    if (!IS_MOBILE) {
      $('.popinEntries__item').each(function() {
        TweenMax.set([$(this).find('.popinEntries__item-subtitle'), $(this).find('.popinEntries__item-title')], {
          y: ($(this).find('.popinEntries__item-text').innerHeight() + $(this).find('.cta').innerHeight()) / 2
        })
  
        TweenMax.set([$(this).find('.popinEntries__item-text'), $(this).find('.cta')], {
          y: 20,
          autoAlpha: 0
        })
  
        $(this).on('mouseenter', () => {
          TweenMax.to([$(this).find('.popinEntries__item-subtitle'), $(this).find('.popinEntries__item-title')], .5, {
            y: 0
          })
    
          TweenMax.staggerTo([$(this).find('.popinEntries__item-text'), $(this).find('.cta')], .5, {
            y: 0,
            autoAlpha: 1
          })
        })
  
        $(this).on('mouseleave', () => {
          TweenMax.to([$(this).find('.popinEntries__item-subtitle'), $(this).find('.popinEntries__item-title')], .5, {
            y: ($(this).find('.popinEntries__item-text').innerHeight() + $(this).find('.cta').innerHeight()) / 2
          })
    
          TweenMax.staggerTo([$(this).find('.popinEntries__item-text'), $(this).find('.cta')], .5, {
            y: 20,
            autoAlpha: 0
          })
        })
      })
  
      $('.bottomPush-item').each(function() {
        TweenMax.set([$(this).find('.bottomPush-item-text'), $(this).find('.bottomPush-item-title')], {
          y: 53
        })
  
        TweenMax.set($(this).find('.cta'), {
          y: 20,
          autoAlpha: 0
        })
  
        $(this).on('mouseenter', () => {
          TweenMax.to([$(this).find('.bottomPush-item-text'), $(this).find('.bottomPush-item-title')], .5, {
            y: 0
          })
    
          TweenMax.staggerTo([$(this).find('.bottomPush-item-text'), $(this).find('.cta')], .5, {
            y: 0,
            autoAlpha: 1
          })
        })
  
        $(this).on('mouseleave', () => {
          TweenMax.to([$(this).find('.bottomPush-item-text'), $(this).find('.bottomPush-item-title')], .5, {
            y: 53
          })
    
          TweenMax.staggerTo($(this).find('.cta'), .5, {
            y: 20,
            autoAlpha: 0
          })
        })
      })
  
      $('.home__block').each(function() {
        TweenMax.set([$(this).find('.home__block-text'), $(this).find('.home__block-title')], {
          y: 53
        })
  
        TweenMax.set($(this).find('.cta'), {
          y: 20,
          autoAlpha: 0
        })
  
        $(this).on('mouseenter', () => {
          TweenMax.to([$(this).find('.home__block-text'), $(this).find('.home__block-title')], .5, {
            y: 0
          })
    
          TweenMax.staggerTo([$(this).find('.home__block-text'), $(this).find('.cta')], .5, {
            y: 0,
            autoAlpha: 1
          })
        })
  
        $(this).on('mouseleave', () => {
          TweenMax.to([$(this).find('.home__block-text'), $(this).find('.home__block-title')], .5, {
            y: 53
          })
    
          TweenMax.staggerTo($(this).find('.cta'), .5, {
            y: 20,
            autoAlpha: 0
          })
        })
      })

      if ($('.page__hero-image').length) {
        $(window).on('scroll', () => {
          TweenMax.to($('.page__hero-image'), .5, {
            scale: window.scrollY * 0.0005 + 1,
            force3D: true
          })
        })
      }
    }
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};
